import React from 'react';
import { useTranslation } from 'react-i18next';

import { SvgIcon } from '../../SvgIcon';
import { TextField, TTextField } from '../TextField';

export const EmailField = React.forwardRef<HTMLInputElement, TTextField>(
  ({ label, placeholder, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <TextField
        {...props}
        type="email"
        label={label}
        placeholder={placeholder ?? t('common:inputs.placeholders.email')}
        autoComplete="email"
        inputMode="email"
        startAdornment={<SvgIcon name="mail-icon" />}
        fullWidth
        ref={ref}
      />
    );
  }
);

EmailField.displayName = 'EmailField';
